import { defineMessages } from 'react-intl';

export default defineMessages({
  file: {
    id: 'app.containers.DocumentForm.file',
    defaultMessage: 'File to be uploaded',
  },
});
